module.exports = __webpack_public_path__ + "img/settings.50264071.svg";